import React, { useState } from "react";
import Pagination_Holder from "../../../../../../../common/common_components/pagination_holder/Pagination_Holder";
import { formatDate } from "../../../../../../../utils/common";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faPen, faTrashCan } from "@fortawesome/free-solid-svg-icons";
import Quality_Plan_Edit_Offcanvas from "../Quality_Plan_Edit_Offcanvas/Quality_Plan_Edit_Offcanvas";
import Delete_offcanvas from "../../../../../../../common/common_offcanvas/delete_offcanvas/Delete_offcanvas";
import { useDispatch, useSelector } from "react-redux";
import { FixIDS } from "../../../../../../../utils/fixIDS";
import { Delete } from "../../../../../../../features/admin/quality_management/process_requirement/quality_control/Slice";

function Quality_Plan_table({
  quality_control_plan,
  currentPage,
  setCurrentPage,
  fetchCustomers,
}) {
  // const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;

  const data = quality_control_plan?.data || [];
  const totalPages = quality_control_plan.total_pages;

  const [showEdit, setEdit] = useState(false);
  const [showEditId, setEditId] = useState(null);

  const [showDelete, setDelete] = useState(false);
  const [selectedDeleteId, setSelectedDeleteId] = useState(null);

  const dispatch = useDispatch();

  // const paginatedData = data.slice(
  //   (currentPage - 1) * itemsPerPage,
  //   currentPage * itemsPerPage,
  // );

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  /* ================= DELETE ================= */
  const handleDelete = async () => {
    if (!selectedDeleteId) return;

    try {
      await dispatch(Delete(selectedDeleteId)).unwrap(); // call redux thunk
      //fetchCustomers(currentPage); // refresh the table
      // setDelete(false); // close offcanvas
      setSelectedDeleteId(null); // reset
      fetchCustomers();
    } catch (err) {
      console.error("Delete failed", err);
      alert("Delete failed");
    }
  };

  const permissions = useSelector((state) => state.auth.permissions);

  const haveEditPermission = permissions?.includes(
    FixIDS.quality_control_plan.Edit,
  );
  const haveDeletePermission = permissions?.includes(
    FixIDS.quality_control_plan.Delete,
  );

  return (
    <section className="Imperiality_table">
      <div className="common_table_container theme_bg">
        <div className="table-responsive">
          <table className="common_table table table-striped customer_table">
            <thead>
              <tr>
                <th>Sr. No</th>
                <th>Date</th>
                <th>Type Of Verification</th>
                <th>Frequency</th>
                <th>Remark</th>
                <th colSpan="2">Acceptance Parameter Criteria</th>
                <th rowSpan="2">Action</th>
              </tr>
              <tr>
                {/*must be 5 (not 4) */}
                <th colSpan="5"></th>
                <th>Parameter</th>
                <th>Value</th>
              </tr>
            </thead>

            <tbody>
              {data.length > 0 ? (
                data.map((item, index) => {
                  const parameters = item?.Quality_Parameters || [];

                  // When parameters exist
                  if (parameters.length > 0) {
                    return parameters.map((param, i) => (
                      <tr key={`${index}-${i}`}>
                        {i === 0 && (
                          <>
                            <td rowSpan={parameters.length}>
                              {(currentPage - 1) * itemsPerPage + index + 1}
                            </td>

                            <td rowSpan={parameters.length}>
                              {formatDate(item?.createdAt) || "-"}
                            </td>

                            <td rowSpan={parameters.length}>
                              {item?.Type_Of_Verification?.name || "-"}
                            </td>

                            <td rowSpan={parameters.length}>
                              {item?.frequency || "-"}
                            </td>

                            <td rowSpan={parameters.length}>
                              {item?.remark || "-"}
                            </td>
                          </>
                        )}

                        {/* Parameter columns */}
                        <td>{param?.Parameter?.name || "-"}</td>
                        <td>{param?.value || "-"}</td>

                        {/* Action */}
                        {i === 0 && (
                          <td rowSpan={parameters.length}>
                            <div className="action_icons">
                              {haveEditPermission && (
                                <FontAwesomeIcon
                                  icon={faPen}
                                  onClick={() => {
                                    setEdit(true);
                                    setEditId(item.id);
                                  }}
                                />
                              )}

                              {haveDeletePermission && (
                                <FontAwesomeIcon
                                  icon={faTrashCan}
                                  onClick={() => {
                                    setSelectedDeleteId(item.id);
                                    setDelete(true);
                                  }}
                                />
                              )}
                            </div>
                          </td>
                        )}
                      </tr>
                    ));
                  }

                  // ✅ When NO parameters
                  return (
                    <tr key={index}>
                      <td>{(currentPage - 1) * itemsPerPage + index + 1}</td>

                      <td>{formatDate(item?.createdAt) || "-"}</td>

                      <td>{item?.Type_Of_Verification?.name || "-"}</td>

                      <td>{item?.frequency || "-"}</td>

                      <td>{item?.remark || "-"}</td>

                      {/* ✅ Fill remaining 2 columns */}
                      <td colSpan="2" className="text-center">
                        No Parameters Found
                      </td>
                    </tr>
                  );
                })
              ) : (
                <tr>
                  {/* ✅ FIX: total columns = 7 */}
                  <td colSpan="7" className="text-center">
                    No Quality Control Plan data found
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>

      {/* FOOTER */}
      <div className="comon_page_footer">
        <div className="show_entry_div">
          <p className="show_text">
            Showing {currentPage} to {data.length} of{" "}
            {quality_control_plan?.total} entries
          </p>
        </div>

        <div className="pagination_div">
          <Pagination_Holder
            onPageChange={currentPage}
            totalPages={totalPages}
            handlePageChange={handlePageChange}
          />
        </div>
      </div>

      {/* Edit */}
      {haveEditPermission && (
        <Quality_Plan_Edit_Offcanvas
          show={showEdit}
          handleClose={() => setEdit(false)}
          id={showEditId}
          offcanvasHeading="Quality Control Plan"
        />
      )}

      {haveDeletePermission && (
        <Delete_offcanvas
          show={showDelete}
          handleClose={() => setDelete(false)}
          handleDelete={handleDelete}
          offcanvasHeading="Delete Quality Control Plan"
          massageText={"Quality Control Plan"}
        />
      )}
    </section>
  );
}

export default Quality_Plan_table;
